import { createReducer, on } from '@ngrx/store';
import { AuthActions } from './auth.actions';
import { initialAuthState, AuthState } from './auth.state';
import { LoginResponse } from '../../features/login/models/login-response.model';

function updateAuthStateFromResponse(
  state: AuthState,
  response: LoginResponse,
): AuthState {
  return {
    ...state,
    roles: response.roles,
    fullName: response.fullName,
    loginId: response.loginId,
    modules: response.modules,
    company: response.company,
    expired: response.expired,
    token: response.token,
    refreshToken: response.refreshToken,
    allowedHotels: response.allowedHotels,
    loaded: true,
    error: null,
  };
}

export const authReducer = createReducer(
  initialAuthState,

  on(AuthActions.login, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),

  on(AuthActions.loginSuccess, (state, { response }) =>
    updateAuthStateFromResponse(state, response),
  ),

  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  })),

  on(AuthActions.tokenLogin, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),

  on(AuthActions.tokenLoginSuccess, (state, { response }) =>
    updateAuthStateFromResponse(state, response),
  ),

  on(AuthActions.tokenLoginFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  })),

  on(AuthActions.changeHotel, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),

  on(AuthActions.changeHotelSuccess, (state, { response }) =>
    updateAuthStateFromResponse(state, response),
  ),

  on(AuthActions.changeHotelFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  })),

  on(AuthActions.logout, () => ({
    ...initialAuthState,
  })),

  on(AuthActions.refreshTokenSuccess, (state, { response }) =>
    updateAuthStateFromResponse(state, response),
  ),

  on(AuthActions.setNewPassword, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),

  on(AuthActions.markLoaded, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),

  on(AuthActions.setNewPasswordSuccess, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),

  on(AuthActions.setNewPasswordFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  })),
);
